<script setup lang="ts">
import { storeToRefs } from 'pinia';

import { locale } from '@/locale';
import { $t } from '@/i18n';
import { usePageStore } from '@/stores';

import CertificationAndTraining from '../components/dashboard/CertificationAndTraining.vue';
import ColleagueConsult from '../components/dashboard/ColleagueConsult.vue';
import DashboardEdos from '../components/dashboard/DashboardEdos.vue';
import DashboardStats from '../components/dashboard/DashboardStats.vue';
import DefaultLayout from '../layouts/DefaultLayout.vue';
import HospitalCertification from '../components/dashboard/HospitalCertification.vue';
import MightyVet from '../components/dashboard/MightyVet.vue';
import PetAndPublicHealth from '../components/dashboard/PetAndPublicHealth.vue';
import PromoBoxx from '../components/dashboard/PromoBoxx.vue';
import QuickLinks from '../components/dashboard/QuickLinks.vue';
import RecordsRequestList from '../components/recordsRequests/RecordsRequestList.vue';
import TasksAndNotifications from '../components/dashboard/TasksAndNotifications.vue';
import TrupanionOnLinkedin from '../components/dashboard/TrupanionOnLinkedin.vue';

const { pageName } = storeToRefs(usePageStore());

pageName.value = $t('pageTitles.Home');

function notFrenchCanadian() {
    return locale.value !== 'fr-CA';
}

function screenWidthTabletOrBelow() {
    return screen.width < 1300;
}
</script>

<template>
    <DefaultLayout>
        <div class="dashboard-page page-content-full-width flex gap-6">
            <div class="column-left flex flex-col gap-6">
                <DashboardEdos />
                <RecordsRequestList :limit="3" />
                <DashboardStats />
                <CertificationAndTraining />
                <HospitalCertification />
                <ColleagueConsult />
                <PetAndPublicHealth />
                <MightyVet v-if="!screenWidthTabletOrBelow() && notFrenchCanadian()" />
                <PromoBoxx />
            </div>

            <div class="column-right flex flex-col gap-6">
                <QuickLinks />
                <TasksAndNotifications />
                <TrupanionOnLinkedin v-if="notFrenchCanadian()" />
                <MightyVet v-if="screenWidthTabletOrBelow()" />
            </div>
        </div>
    </DefaultLayout>
</template>

<style lang="scss">
@use '../scss/variables' as *;

#app .bodyMain .body-content {
    padding: 3rem 3rem 0;
}

.dashboard-page {
    min-width: 123.75rem;
    max-width: 160rem;

    .column-left {
        width: 60%;
    }

    .column-right {
        width: 40%;
    }

    .trupanion-on-linkedin {
        img {
            width: 100%;
        }

        p {
            padding: 2rem 0;
            color: #222725;
            font-family: Mulish;
            font-weight: 400;
            line-height: 2.75rem;
        }
    }

    .records-header {
        position: relative;
    }

    .norecords-title {
        .tru-card-body {
            padding: 2.5rem 1rem 2rem;
            font-size: 1.75rem;
            line-height: 2.5rem;
        }
    }
}

@media screen and (max-width:1300px) {
    .dashboard-page {
        flex-direction: column;
        min-width: 0;

        .column-left,
        .column-right {
            width: 100%;
        }
    }
}
</style>
